<template>
  <div class="page-content accounts-info-container">
    <div class="row">
      <div class="col-sm-6 col-12">
        <ChangePassword />
      </div>

      <div class="col-sm-6 col-12">
        <NewRequestAccess />
      </div>
    </div>
    <OperatorActivitiesSummary
      page-id="operator-activities-summary"
      is-current-user
    />
    <OperatorActivities
      page-id="operator-activities"
      is-current-user
    />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const ChangePassword = defineAsyncComponent(() => import('@/components/UIComponents/Account/ChangePassword.vue') as any);
const OperatorActivities = defineAsyncComponent(() => import('./Operator/OperatorActivities.vue') as any);
const NewRequestAccess = defineAsyncComponent(() => import('./Account/NewRequestAccess.vue') as any);
const OperatorActivitiesSummary = defineAsyncComponent(() => import('./Operator/OperatorActivitiesSummary.vue') as any);

const route = useRoute();

onMounted(async () => {
  const { hash } = route;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
